<template>
  <div class="posterPlace">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>广告位列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>位置名称:</span>
      <el-input
        v-model="list.placeName"
        placeholder="请输入位置名称"
      ></el-input>
      <span>位置编码:</span>
      <el-input
        v-model="list.placeCode"
        placeholder="请输入位置编码"
      ></el-input>
      <el-button type="primary" @click="getposterPlaceList()">查找</el-button>
      <el-button
        type="primary"
        @click="addDialogVisible = true"
        v-if="$store.state.powerList.indexOf('place:info:list:select') !== -1"
        >添加</el-button
      >
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <!-- <el-table-column align="center" type="selection"></el-table-column> -->
      <el-table-column
        align="center"
        prop="placeId"
        label="广告位ID"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="placeName"
        label="广告位名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="placeCode"
        label="广告位编码"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="fatherName"
        label="上级名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="addTime"
        label="添加时间"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            size="mini"
            @click="onEdit(row)"
            v-if="$store.state.powerList.indexOf('place:info:list:edit') !== -1"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="$router.push(`/secondPoster/${row.placeId}`)"
            >查看下级</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="list.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="list.total"
    >
    </el-pagination>

    <!-- 添加广告位弹层 -->
    <el-dialog
      :close-on-click-modal="false"
      title="添加位置"
      :visible.sync="addDialogVisible"
      width="30%"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="广告位名称">
          <el-input
            v-model="addFormList.placeName"
            placeholder="请输入广告位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告位编码">
          <el-input
            v-model="addFormList.placeCode"
            placeholder="请输入广告位编码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAddOk">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑广告位弹层 -->
    <el-dialog
      :close-on-click-modal="false"
      title="添加位置"
      :visible.sync="editDialogVisible"
      width="30%"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="广告位名称">
          <el-input
            v-model="editFormList.placeName"
            placeholder="请输入广告位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告位编码">
          <el-input
            v-model="editFormList.placeCode"
            placeholder="请输入广告位编码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  posterPlaceList,
  addOrEditPosterPlace,
} from "../../../api/posterPlace";
export default {
  name: "posterPlace",
  data() {
    return {
      tableData: [],
      pagination: {},
      addDialogVisible: false,
      editDialogVisible: false,
      addFormList: {
        placeId: 0,
        fatherId: 0,
        placeName: "",
        placeCode: "",
      },
      editFormList: {
        placeId: null,
        fatherId: 0,
        placeName: "",
        placeCode: "",
      },
      list: {
        currentPage: 1,
        pageSize: 10,
        fatherId: 0,
        placeName: "",
        placeCode: "",
      },
    };
  },
  created() {
    this.getposterPlaceList();
  },
  methods: {
    async getposterPlaceList() {
      const { data } = await posterPlaceList(this.list);
      this.tableData = data.list;
      this.list.total = data.pagination.total;
      this.list.pageSize = data.pagination.pageSize;
      this.list.currentPage = data.pagination.current;
    },
    async onEditOk() {
      if (
        this.editFormList.placeName == "" ||
        this.editFormList.placeCode == ""
      ) {
        return this.$message.error("请把信息填写完整");
      }
      const { data } = await addOrEditPosterPlace(this.editFormList);
      if (data.code == 0) {
        this.getposterPlaceList();
        this.$message({
          message: data.msg,
          type: "success",
        });
      } else {
        this.$message.error(data.msg);
      }
      this.editDialogVisible = false;
    },
    onEdit(row) {
      this.editFormList.placeId = row.placeId;
      this.editFormList.placeName = row.placeName;
      this.editFormList.placeCode = row.placeCode;
      this.editFormList.placeName = row.placeName;

      this.editDialogVisible = true;
    },
    async onAddOk() {
      if (
        this.addFormList.placeName == "" ||
        this.addFormList.placeCode == ""
      ) {
        return this.$message.error("请把信息填写完整");
      }
      const { data } = await addOrEditPosterPlace(this.addFormList);
      if (data.code == 0) {
        this.getposterPlaceList();
        this.$message({
          message: data.msg,
          type: "success",
        });
      } else {
        this.$message.error(data.msg);
      }
      this.addDialogVisible = false;
      this.addFormList.placeName = "";
      this.addFormList.placeCode = "";
    },
    handleSizeChange(num) {
      console.log(num);
      this.list.pageSize = num;
      this.getposterPlaceList();
    },
    handleCurrentChange(num) {
      console.log("currentPage", num);
      this.list.currentPage = num;
      this.getposterPlaceList();
    },
  },
};
</script>
<style lang="less" scoped>
.posterPlace {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    span {
      margin: 0 20px 0 40px;
    }
    .el-button {
      margin-left: 20px;
    }
    .el-input {
      width: 350px;
    }
  }
  .el-table {
    margin-top: 50px;
  }
}
</style>